import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import styled from '@emotion/styled';

import { FullTextLogo } from '../CompanyLogo';
import { CompanyLetterLogo } from '../CompanyLogo/CompanyLogo';

interface IAuthLayout {
  children?: any;
  label?: string;
  linkTitle?: string;
  linkPath?: string;
  formHeaderTitle?: string;
  formHeaderDescription?: string | React.ReactNode;
  forgotPassword?: boolean;
  headerImgSrc?: string;
}

export const AuthLayout: React.FC<IAuthLayout> = ({
  children,
  formHeaderTitle,
  formHeaderDescription,
  forgotPassword,
  headerImgSrc,
}) => {
  return (
    <Container>
      <FormAreaHeader>
        <FullTextLogo />
      </FormAreaHeader>
      <FormAreaHeader className="small-screens">
        <CompanyLetterLogo />
      </FormAreaHeader>
      <FormSectionWrapper>
        <FormSection>
          {headerImgSrc && <FormSectionHeaderImg src={headerImgSrc} />}
          <FormSectionHeader>
            <FormSectionHeaderTitle>{formHeaderTitle}</FormSectionHeaderTitle>
            <FormSectionHeaderDescription>
              {formHeaderDescription}
            </FormSectionHeaderDescription>
          </FormSectionHeader>
          <FormBody>{children}</FormBody>
          {forgotPassword && (
            <ForgotPasswordLink to="/account/reset-password">
              Forgot password
            </ForgotPasswordLink>
          )}
        </FormSection>
      </FormSectionWrapper>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  position: relative;
`;

const FormAreaHeader = styled.div`
  position: absolute;
  left: 2rem;
  top: 2rem;

  @media screen and (max-width: 480px) {
    display: none;
  }

  &.small-screens {
    display: none;
    @media screen and (max-width: 480px) {
      display: block;
      left: 1rem;
      top: 1rem;
    }
  }
`;

const FormSectionWrapper = styled.div`
  display: flex;
  height: 100%;
  /* background-color: white; */
  display: grid;
  place-content: center;
`;

const FormSection = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.text1};
  border-radius: 0.5rem;
  height: fit-content;
  padding: 2.5rem;
  display: grid;
  gap: 1.5rem;
  background-color: white;

  @media (max-width: 480px) {
    background-color: transparent;
    border: none;
  }
`;

const FormSectionHeaderImg = styled.img`
  width: 16rem;
  align-self: center;
  margin: auto;
`;

const FormBody = styled.div`
  @media (max-width: 480px) {
    width: 100%;
  }
`;

const FormSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const FormSectionHeaderTitle = styled.div`
  display: flex;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primaryText};
`;

const FormSectionHeaderDescription = styled.div`
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  width: 22rem;
  color: ${({ theme }) => theme.palette.secondaryText};

  @media (max-width: 480px) {
    width: 90vw;
  }
`;

const Link = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.brandPrimary};
  font-weight: 700;
`;

const ForgotPasswordLink = styled(Link)`
  text-align: center;
`;
